import React, {useEffect, useRef, useState} from 'react';
import "./Resources.sass"
import x_icon from '../../icons/x_icon.svg'
import {toggleResources} from "../../store/actions/course.action";
import renderHTML from 'react-render-html';
import {useDispatch} from "react-redux";
import apiJSON from "../../api/apiJSON";

const Resources = ({data, id, initSelection}) => {

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const displayPanel = useRef(null);
    const dispatch = useDispatch();

    const jsonData = apiJSON.get(data);

    useEffect(() => {
        console.log("Resources useEffect initSelection:"+initSelection)
        if(initSelection){
            setSelectedIndex(getSelectionIndex(initSelection))
        }
    }, []);

    useEffect(()=>{
        console.log("selectedIndex: "+selectedIndex)
    },[selectedIndex])


    const getSelectionIndex = (id) =>{
        console.log("getSelectionIndex("+id+")");
        for(var i=0;i<jsonData.items.length;i++){
            if(jsonData.items[i].id==id){
                return  i;
            }
        }
       return  -1;
    }

    const handleSelect = (index) => {
        console.log("handleSelect(" + index+ ")");
        setSelectedIndex(index)
    }

    const hide = () =>{
        dispatch(toggleResources(false))
    }


    return (
        <div id={id} className="Resources invisible">
            <div ref={displayPanel} className="resources-panel">

                <div className="resources-panel-header">
                    {jsonData.header}
                </div>
                <div className="resources-panel-display">
                    <div className="resources-panel-items">{
                        (jsonData.items ? (jsonData.items.map((item, index) => (
                            <div className={selectedIndex === index ? "resources-panel-item selected" : "resources-panel-item"}
                                 key={index}
                                 onClick={() => {
                                     handleSelect(index)
                                 }}>{item.label}</div>
                        ))) : null)
                    }
                    </div>
                    {selectedIndex > -1 ? (
                        <div className="resources-panel-item-display">
                        <div className="resources-panel-item-display title">
                            {jsonData.items[selectedIndex].title}
                        </div>
                            <div className="resources-panel-item-display body">
                            {renderHTML(jsonData.items[selectedIndex].body)}
                        </div>
                        </div>) : null}

                </div>
                <div className="close-button" onClick={hide}>
                    <img src={x_icon}/>
                </div>
            </div>
            <div className="scrim"/>
        </div>
    );
};

export default Resources;